import { useRouter } from '@tanstack/react-router';
import { createContext, use } from 'react';
import { graphql, useFragment, useMutation } from 'react-relay';
// import { fetchQuery } from 'relay-runtime';
import type { processDefinitionsArchivedQueryFragment$key } from './__generated__/processDefinitionsArchivedQueryFragment.graphql';
import type { processDefinitionsArchivedQueryDeleteMutation } from './__generated__/processDefinitionsArchivedQueryDeleteMutation.graphql';
// import type { processDefinitionsArchivedQueryXmlQuery } from './__generated__/processDefinitionsArchivedQueryXmlQuery.graphql.ts';

// https://github.com/jakst/tanstack-router-relay/blob/main/src/routes/index.lazy.tsx

// PANDING/LOADING STATE
// TSR - https://github.com/TanStack/router/blob/92c6c2b1ff3bbf661c6aed7fbda84c8233d0a30e/examples/react/kitchen-sink-file-based/src/routes/__root.tsx
// TSR - https://tanstack.com/router/latest/docs/framework/react/api/router/matchRouteComponent
// RR - https://www.geeksforgeeks.org/how-relay-is-different-from-redux/

export const ProcessDefinitionsArchivedQueryCtx = createContext<
    processDefinitionsArchivedQueryFragment$key | null | undefined
>(null);

const processDefinitionsArchivedQueryFragment = graphql`
    fragment processDefinitionsArchivedQueryFragment on ProcessDefinitionPage {
        content {
            createdAt
            id
            definitionKey
            definitionName
            definitionVersion
            modifiedAt
            startWhen
            status
            listName
        }

        pageInfo {
            ...listPaginationQueryFragment
        }
    }
`;

export const useProcessDefinitionsArchivedQueryFragment = () =>
    useFragment(processDefinitionsArchivedQueryFragment, use(ProcessDefinitionsArchivedQueryCtx));

export const useProcessDefinitionsArchivedQueryFragmentRef = (
    fragmentRef?: processDefinitionsArchivedQueryFragment$key
) => useFragment(processDefinitionsArchivedQueryFragment, fragmentRef);

/*const gqlDelete = graphql`
    mutation processDefinitionsQueryDeleteMutation($ids: [ID!]!) {
        deleteProcessDefinitions(ids: $ids)
    }
`;

export const useProcessDefinitionsDelete = () => useMutation<TDelete>(gqlDelete);*/

export const useProcessDefinitionsArchivedQueryRefresh = (): (() => void) => {
    const router = useRouter();
    return () => {
        router.invalidate();
    };
};

const gqlDelete = graphql`
    mutation processDefinitionsArchivedQueryDeleteMutation($ids: [ID!]!) {
        deleteProcessDefinitions(ids: $ids)
    }
`;

export const useProcessDefinitionsArchivedDelete = () =>
    useMutation<processDefinitionsArchivedQueryDeleteMutation>(gqlDelete);

/*const gqlXml = graphql`
    query processDefinitionsArchivedQueryXmlQuery($id: ID!) {
        getProcessDefinition(id: $id) {
            definitionXml
        }
    }
`;

export const useProcessDefinitionsArchivedQueryXml = () => {
    const relayEnv = useRelayEnvironment();
    return (id: string) =>
        fetchQuery<processDefinitionsArchivedQueryXmlQuery>(relayEnv, gqlXml, { id })
            .toPromise()
            .then((result) => result?.getProcessDefinition?.definitionXml);
};*/
